import { ref as l, computed as p, onMounted as b, createElementBlock as r, openBlock as c, createElementVNode as t, toDisplayString as s, Fragment as v, renderList as _, normalizeClass as g, createTextVNode as m, createVNode as C, unref as S } from "vue";
import T from "highlight.js";
import { copyToClipboard as j } from "../../utils/functions/clipboard.js";
/* empty css                  */
import k from "../../atoms/icon-core/icon-core.vue.js";
const x = { class: "ds-code-snippet" }, E = {
  class: "ds-color-grey-3200 ds-text-small ds-margin-bottom-3 ds-margin-bottom-12 ds-font-weight-semi-bold",
  "data-j-language": ""
}, N = { class: "ds-position-relative" }, A = { class: "ds-code-snippet__lines" }, H = ["innerHTML"], L = "DsCodeSnippet", w = 24, B = /* @__PURE__ */ Object.assign({
  name: L
}, {
  __name: "code-snippet",
  props: {
    /**
     * Label, required.
     * Renders 'language' above code snippet
     *
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Language, required.
     * Renders and styles the language chosen
     */
    language: {
      type: String,
      required: !0,
      validator: (e) => [
        "html",
        "xml",
        "css",
        "javascript",
        "json",
        "java",
        "ruby",
        "php",
        "python",
        "go",
        "c",
        "c#",
        "bash",
        "kotlin",
        "rust",
        "plaintext"
      ].includes(e)
    },
    /**
     * Source Code, required.
     * Renders the code
     */
    sourceCode: {
      type: String,
      required: !0
    },
    /**
     * No wrap, default false - text wraps within container
     */
    noWrap: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const o = e, d = l(0), a = l(!1), i = l(null), y = p(() => o.sourceCode ? T.highlightAuto(o.sourceCode).value : null), f = p(() => a.value ? "Copied" : "Copy");
    b(() => {
      i.value && (d.value = Math.ceil(i.value.offsetHeight / w));
    });
    const h = async () => {
      a.value = !0, await j(o.sourceCode), setTimeout(() => {
        a.value = !1;
      }, 600);
    };
    return (D, n) => (c(), r("div", x, [
      t("div", E, s(e.label) + " " + s(e.language), 1),
      t("div", N, [
        t("div", A, [
          (c(!0), r(v, null, _(d.value, (u) => (c(), r("div", {
            key: `line-number-${u}`,
            "data-j-lines": ""
          }, s(u), 1))), 128))
        ]),
        t("pre", {
          class: g(["ds-code-snippet__code", { "ds-white-space-pre-wrap": !e.noWrap }])
        }, [
          n[0] || (n[0] = m("        ")),
          t("code", {
            ref_key: "target",
            ref: i,
            class: g(e.language),
            "data-j-code": "",
            innerHTML: y.value
          }, null, 10, H),
          n[1] || (n[1] = m(`
      `))
        ], 2),
        t("button", {
          type: "button",
          "aria-label": "Copy source",
          class: "ds-position-absolute ds-code-snippet__copy-button ds-button-link-icon ds-button-link-icon--green",
          "data-j-copy-button": "",
          onClick: h
        }, [
          C(S(k), {
            category: "interface",
            name: "copy"
          }),
          t("span", null, s(f.value), 1)
        ])
      ])
    ]));
  }
});
export {
  B as default
};
